import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

const Wrapper = styled.div`
  width: 940px;
  background: #673490;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  color: #fff;
  font-size: 1.4em;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 0 15px #dcdcdc;

  ${mediaMaxWidth.smallDesktop} {
    width: calc(100vw - 80px);
    margin-bottom: 15px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    font-size: 1em;
    text-align: center;
  }
`;

export { Wrapper as default };
